/**
 * StateStore.ts - Подійна модель та централізоване керування станом (State Manager & Event Bus)
 * Для відмови від монолітного розрізненого стану.
 */

export type StateListener<T> = (data: T) => void;

class EventBus {
  private events: { [key: string]: Function[] } = {};

  on(event: string, fn: Function) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(fn);
  }

  off(event: string, fn: Function) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== fn);
  }

  emit(event: string, data?: any) {
    if (!this.events[event]) return;
    this.events[event].forEach(cb => cb(data));
  }
}

export const eventBus = new EventBus();

// Налаштування віджетів дашборду
export interface DashboardWidgetConfig {
  tasks: boolean;
  projects: boolean;
  finances: boolean;
  goals: boolean;
  training: boolean;
  quote: boolean;
}

const DEFAULT_WIDGETS: DashboardWidgetConfig = {
  tasks: true,
  projects: true,
  finances: true,
  goals: true,
  training: true,
  quote: true
};

class DashboardStore {
  private config: DashboardWidgetConfig;

  constructor() {
    const saved = localStorage.getItem('bb_dashboard_widgets');
    this.config = saved ? JSON.parse(saved) : { ...DEFAULT_WIDGETS };
  }

  getConfig(): DashboardWidgetConfig {
    return { ...this.config };
  }

  toggleWidget(key: keyof DashboardWidgetConfig, isVisible: boolean) {
    this.config[key] = isVisible;
    localStorage.setItem('bb_dashboard_widgets', JSON.stringify(this.config));
    eventBus.emit('dashboard:widgets-changed', this.config);
  }
}

export const dashboardStore = new DashboardStore();

// Attach UI listener for Widget Settings Button
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('dash-btn-widget-settings');
  if (btn) {
    btn.addEventListener('click', () => {
      const cfg = dashboardStore.getConfig();
      const newTasks = !cfg.tasks;
      dashboardStore.toggleWidget('tasks', newTasks);
      const toastMsg = newTasks ? 'Віджет "Задачі" увімкнено!' : 'Віджет "Задачі" приховано!';
      (window as any).showMessage?.(toastMsg, 'info');
    });
  }
});

